export enum ETelemetryActionsAndLabels {
  Create = "create",
  Click = "click",
  View = "view",
  Edit = "edit",
}
export enum ETelemetryNames {
  PaymentProfile = "PaymentProfile",
  BillingAndPaymentsDashboard = "BillingAndPaymentsDashboard",
  MyBills = "MyBills",
  Cancellation = "Cancellation",
  ProductManagement = "ProductManagement",
  ErrorPage = "ErrorPage",
}
